export default __webpack_public_path__ + "static/media/videocase4.ef783e25.png";